/* eslint-disable no-useless-escape */
/* eslint-disable prettier/prettier */
import SearchIcon from '@mui/icons-material/Search';
import Card, { CardProps } from '@mui/material/Card';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import { alpha, styled } from '@mui/material/styles';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { VerticalScroll } from '@qpr/components';
import HierarchyTree from '@qpr/components/HierarchyTree/HierarchyTree';
import React from 'react';

const PREFIX = 'HieararchyCard';

const classes = {
  searchInput: `${PREFIX}-searchInput`,
  columnContainer: `${PREFIX}-columnContainer`,
  scrollContent: `${PREFIX}-scrollContent`,
  title: `${PREFIX}-title`
};
interface HierarchyCardProps extends React.PropsWithChildren<CardProps> {
  data: Hierarchy[];
  title: string;
  onSearchChange: any;
  onChildClick: any;
  onParentClick: any;
  searchTerm: string;
  'data-testid'?: string;
  className?: string;
  selectedIds?: (string | undefined)[];
  ChildIcon: React.ElementType<SvgIconProps<'svg', {}>>;
}

const StyledCard = styled(Card)(({ theme }) => ({
  [`& .${classes.searchInput}`]: {
    background: theme.palette.grey[300],
    padding: theme.spacing(1),
    borderRadius: 4,
    marginBottom: theme.spacing(1)
  },

  [`& .${classes.columnContainer}`]: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },

  [`& .${classes.scrollContent}`]: {
    flexGrow: 1,
    display: 'flex',
    overflowY: 'auto'
  },

  [`& .${classes.title}`]: {
    color: alpha(theme.palette.text.primary, 0.9)
  }
}));

interface Hierarchy {
  id: string;
  name: string;
  children?: Hierarchy[];
}

interface HierarchyCardProps extends React.PropsWithChildren<CardProps> {
  data: Hierarchy[];
  title: string;
  onSearchChange: any;
  onChildClick: any;
  onParentClick: any;
  searchTerm: string;
  'data-testid'?: string;
  className?: string;
  ChildIcon: React.ElementType<SvgIconProps<'svg', {}>>;
}

const HieararchyCard = ({
  title,
  data,
  onSearchChange,
  onChildClick,
  onParentClick,
  searchTerm,
  ChildIcon,
  selectedIds,
  ...cardProps
}: HierarchyCardProps) => {
  return (
    <StyledCard {...cardProps}>
      <div className={classes.columnContainer}>
        <FormControl fullWidth>
          <Typography
            className={classes.title}
            variant="subtitle1"
            data-testid="hierarchy-card-title"
          >
            {title}
          </Typography>
          <Input
            data-testid="hierarchy-card-search-input"
            onChange={onSearchChange}
            className={classes.searchInput}
            disableUnderline
            placeholder="Search"
            id="input-with-icon-adornment"
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
            value={searchTerm}
          />
        </FormControl>
        <div className={classes.scrollContent}>
          <VerticalScroll>
            <HierarchyTree
              data={data}
              childOnClick={onChildClick}
              parentOnClick={onParentClick}
              ChildIcon={ChildIcon}
              selectedIds={selectedIds}
            />
          </VerticalScroll>
        </div>
      </div>
    </StyledCard>
  );
};

export default HieararchyCard;
